/** The ShowGeometryDialogButtonEvent is dispatched when the user presses the button that shows the geometry dialog. */
export default class ShowGeometryDialogButtonEvent extends Event {
	/**
	 * The static SHOW_GEOMETRY_DIALOG_BUTTON_CLICKED type is dispatched when the button is clicked or while focused, the Space or Enter key is pressed.
	 *
	 * Example: addEventListener(ShowGeometryDialogButtonEvent.SHOW_GEOMETRY_DIALOG_BUTTON_CLICKED, (event: ShowGeometryDialogButtonEvent) => {});
	 */
	public static SHOW_GEOMETRY_DIALOG_BUTTON_CLICKED = 'ShowGeometryDialogButtonEvent.showGeometryDialogButtonClicked';

	public constructor() {
		super(ShowGeometryDialogButtonEvent.SHOW_GEOMETRY_DIALOG_BUTTON_CLICKED, { bubbles: true });
	}
}
